export default {
  setReviews: (state, payload) => { state.reviews = payload },
  setReview: (state, payload) => { state.review = payload },
}